<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-slide-group class="py-0" center-active mandatory show-arrows>
          <!-- Slot ปุ่มกดฝั่งซ้าย (Prev) -->
          <template v-slot:prev="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>

          <!-- Slot ปุ่มกดฝั่งขวา (Next) -->
          <template v-slot:next="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>

          <v-slide-item
            v-for="cate in categoryList"
            :key="cate.id"
            v-slot="{ active, toggle }"
            @change="initialize(cate)"
          >
            <v-card
              rounded="lg"
              class="px-2 mx-1"
              @click="toggle"
              elevation="0"
              width="15%"
              :style="
                active
                  ? { border: '1.5px solid', 'border-color': site.color }
                  : ''
              "
            >
              <v-container class="pa-0">
                <v-col class="d-flex justify-center pt-2 pb-0">
                  <v-icon :color="site.color">{{ `mdi-${cate.icon}` }}</v-icon>
                </v-col>
                <p style="font-size: 12px" class="text-center mb-0">
                  {{ cate.label }}
                </p>
              </v-container>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-container class="pt-0 mt-2">
      <v-row class="mt-1">
        <v-col
          v-for="(item, index) in dataItems"
          :key="index"
          class="px-2 py-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              :class="{ 'disabled-card': item.limit_reached }"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              :disabled="checkExpire(item.expires_at, item.limit_reached)"
              @click="confirmRedeem(item)"
            >
              <div
                v-if="item.limit_reached"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("rewardLimitReached") }}</div>
              </div>
              <div
                v-else-if="item.status == 'coming soon'"
                class="d-flex justify-center align-center text-center cover-card-disable"
              >
                <div class="label">{{ $t("rewardComingSoon") }}</div>
              </div>

              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>

              <v-row
                v-if="!checkExpire(item.expires_at)"
                class="bottomleft mb-0 text-start text-subtitle-2"
                style="width: calc(100% - 16px)"
              >
                <div
                  v-if="
                    Array.isArray(item.point_used) && item.point_used.length > 0
                  "
                  class="d-flex align-center ma-1"
                  style="width: 100%"
                >
                  <div class="mr-2">
                    <PointSymbol
                      :type="item.point_used[0].point_type_type"
                      :symbol="item.point_used[0].point_type_symbol"
                      :color="item.point_used[0].point_type_color"
                      :is_display="true"
                      :outlined_box="false"
                      :size="20"
                    />
                  </div>
                  <p class="pa-0 pl-0 my-0 text-truncate">
                    {{ item.point_used[0].point | commaPoint }}
                    {{ item.point_used[0].point_type_name }}
                  </p>
                </div>
              </v-row>

              <v-row class="bottomleft mb-0 text-start text-subtitle-2" v-else>
                <v-img
                  :src="require('@/assets/images/expired.png')"
                  max-height="20"
                  max-width="20"
                  class="ma-1 d-block"
                ></v-img>
                <p class="pa-0 my-1 pl-0 text-truncate">
                  {{ $t("expireTime") }}
                </p>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <v-dialog v-model="dialogDeleteFavorite" persistent max-width="290">
      <v-card>
        <v-card-text class="text-h6 text-center mt-0 pa-4">
          {{ $t("confirmDelete") }} <br />
          <span :style="{ color: site.color }" class="font-weight-bold">{{
            item.name
          }}</span
          ><br />
          {{ $t("fromYourFav") }} ?
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="deleteFavorite()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogDeleteFavorite = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog detail reward -->
    <dialogDetailReward
      :dialogDetail="dialogDetail"
      :item="item"
      :site="site"
      :keyComponent="keyComponent"
      @deleteFavorite="deleteFavorite"
      @redeemRewardFinal="redeemRewardFinal"
      @close="dialogDetail = false"
    />

    <!-- Fern: Confirm Redeem Final dialog -->
    <DialogConfirmRedeemFinal
      :dialogConfirmRedeemFinalVisible="dialogConfirmRedeemFinalVisible"
      :site="site"
      :item="item"
      :quantity="quantity"
      @close="closeConfirmDialog()"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import HeaderTextBg from "@/components/headerTextBg.vue";
import dialogDetailReward from "@/components/reward/dialogDetail.vue";
import DialogConfirmRedeemFinal from "@/components/reward/dialogConfirmRedeemFinal.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    dialogDetailReward,
    DialogConfirmRedeemFinal,
    PointSymbol,
  },
  data: () => ({
    data: [],
    group: null,
    model: null,
    dataItems: [],
    dialogDeleteFavorite: false,
    dialogDetail: false,
    dialogConfirmRedeemFinalVisible: false,
    item: "",
    next_page_url: "",
    infiniteId: +new Date(),
    keyComponent: 0,
    quantity: null,
    category: "all",
    categoryList: [],
  }),
  created() {
    this.getCategory();
    this.initialize({
      value: this.category,
    });
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "favorite-item");
    this.title = model?.name;
  },
  methods: {
    // ========== ========== ========== ==========
    initialize(cate) {
      this.isAppLoading(true);
      this.dialogDetail = false;
      this.dataItems = [];
      this.category = cate ? cate.value : "all";
      Axios.get("reward/favoriteItems", {
        params: {
          category: this.category,
        },
      })
        .then(({ data }) => {
          if (data?.status == "success") {
            this.dataItems = data.data || [];
          }
        })
        .catch((err) => {
          console.log("initialize[err]", err);
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    getCategory() {
      Axios.get("reward/listRewardCategory").then(({ data }) => {
        if (data.status == "success") {
          let cate = data.data;
          cate.map((item) => {
            this.categoryList.push({
              icon: item.icon,
              label: item.label,
              value: item.category,
            });
          });
          this.categoryList.unshift({
            icon: "order-bool-ascending",
            label: this.$t("categoryAll"),
            value: "all",
          });
        }
      });
    },

    // ========== ========== Favorite ========== ==========
    deleteFavorite() {
      Axios.delete(`reward/deleteFavoriteItem`, {
        data: { reward_id: this.item.id },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
            this.initialize({
              value: this.category,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    // ========== ========== Map ========== ==========
    checkExpire(date, limit_reached) {
      if (limit_reached) return limit_reached;
      return moment().isAfter(date, "day");
    },

    // ========== ========== ========== ==========
    confirmRedeem(item) {
      if (item.limit_reached) return;
      this.item = item;
      Axios.get(`reward/getReward`, {
        params: {
          reward_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            this.item = { ...this.item, ...data };
            this.dialogDetail = true;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    closeConfirmDialog() {
      this.dialogDetail = true;
      this.dialogConfirmRedeemFinalVisible = false;
    },
    redeemRewardFinal(quantity) {
      this.quantity = quantity;
      this.dialogDetail = false;
      this.dialogConfirmRedeemFinalVisible = true;
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 100;
    },
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.v-btn__content {
  display: flex;
  flex-direction: column;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.bar-header {
  height: 150px;
  border-bottom-left-radius: 25px !important;
  font-size: 14px;
  border-bottom-right-radius: 25px !important;
}
.bar-image {
  height: 210px;
  font-size: 14px;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 3px;
}
.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.v-slide-group__content {
  justify-content: start !important;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}
.empty {
  opacity: 1;
}
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}
.disabled-card {
  /* background-color: #00000033; */
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  /* background-color: #00000099; */
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  /* color: #FFFFFF; */
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
}

.custom-slide-btn {
  background-color: #ffffff !important;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.custom-slide-btn:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.08);
}

.custom-slide-btn .v-icon {
  color: #333333 !important;
}
</style>
